import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ButtonBase from '../ButtonBase/ButtonBase'
import ButtonContent from '../ButtonContent/ButtonContent'
import ButtonIcon from './ButtonIcon/ButtonIcon'

import s from './ButtonWithIcons.scss'


const ButtonWithIcons = (props) => {
  const {
    children, title, size, loading, fullWidth, centering, noPadding,
    leftIcon, rightIcon,
    ...rest
  } = props

  const dummyIcon = <svg height={fullWidth ? '100%' : '50%'} viewBox="0 0 1 1" />

  return (
    <ButtonBase size={size} fullWidth={fullWidth} {...rest}>
      <div className={cx(s.content, { [s.center]: centering })}>
        {
          leftIcon ? (
            <ButtonIcon icon={leftIcon} />
          ) : (
            dummyIcon
          )
        }
        <ButtonContent {...{ children, title, size, loading, centering, noPadding }} />
        {
          rightIcon ? (
            <ButtonIcon icon={rightIcon} />
          ) : (
            dummyIcon
          )
        }
      </div>
    </ButtonBase>
  )
}

ButtonWithIcons.propTypes = {
  leftIcon: PropTypes.string,
  rightIcon: PropTypes.string,
  centering: PropTypes.bool,
  ...ButtonBase.propTypes,
  ...ButtonContent.propTypes,
}


export default ButtonWithIcons
